import React from "react";
import i18next from "i18next"
import { getWitnessType } from "../../../../common/getString"
import { useTranslation } from "react-i18next";

interface IWitnessDetailsAndCommentsProps {
  witness_full_name?: string;
  host_name?: string;
  witness_type?: string;
  comments_for_guests?: string;
  witness_presentation_details?: string;
}

const WitnessDetailsAndComments = ({
    witness_full_name,
    host_name,
    witness_type,
    comments_for_guests,
    witness_presentation_details
  }: IWitnessDetailsAndCommentsProps) => {
    const { t } = useTranslation();
    return (
      <>
      {
        witness_full_name && (
          <>
            <p style={{marginBottom: '10px'}}>
            {i18next.t('guests.salonSearchMap.witnessAndSalonDetails', {
                witnessName: witness_full_name,
                hostName: host_name,
                witnessType:t(getWitnessType(witness_type)),
                witnessPresentationDetails: witness_presentation_details ? `, ${witness_presentation_details}` : ''
            })}
            </p>
          </>
        )
      }
      {
        comments_for_guests && <span>{ comments_for_guests }</span>
      }
    </>
    )
}
export default WitnessDetailsAndComments;